import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptContentOrders } from "../adapters/adaptContentOrders";

const fetchContentOrders = async () => {
	const response = await cmsClient.get<IContentOrder[]>(
		"/homepage/admin/content-order/"
	);

	return response.data;
};

const useContentOrders = () => {
	const query = useQuery(["content-orders"], fetchContentOrders, {
		select: adaptContentOrders
	});

	return query;
};

export default useContentOrders;
